import isFilledUp from './fields/isFilledUp'
import isEmail from './fields/isEmail'

const validateAccountIdentifier = (name, accountIdentifier) => {
  if (!isFilledUp(accountIdentifier)) {
    return { [name]: 'Email Address is required' }
  }
  if (!isEmail(accountIdentifier)) {
    return { [name]: 'Invalid email address' }
  }
  return {}
}

const validate = values => {
  if (typeof values !== 'object' || values === null) {
    throw new Error(
      'Invalid argument. Validator functions only expect a non-null object.',
    )
  }

  const { accountIdentifier } = values

  return {
    ...validateAccountIdentifier('accountIdentifier', accountIdentifier),
  }
}

export default validate
